document.addEventListener('DOMContentLoaded', function () {

  // NAV SCROLL
  const nav = document.querySelector('.corvea-nav, header');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    });
  }

  // SCROLL REVEAL
  const reveals = document.querySelectorAll('.corvea-reveal');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.classList.add('visible');
        }, entry.target.dataset.delay || 0);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  reveals.forEach((el, i) => {
    el.dataset.delay = i * 60;
    observer.observe(el);
  });

  // SIZE BUTTONS
  document.querySelectorAll('.corvea-size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.corvea-product-page__size-grid')
        .querySelectorAll('.corvea-size-btn')
        .forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // NEWSLETTER
  const nlForm = document.querySelector('.corvea-newsletter__form');
  if (nlForm) {
    nlForm.addEventListener('submit', e => {
      e.preventDefault();
      const input = nlForm.querySelector('.corvea-newsletter__input');
      const btn = nlForm.querySelector('.corvea-newsletter__btn');
      if (input.value) {
        btn.textContent = '✓ Angemeldet';
        btn.style.background = '#222';
        input.value = '';
        setTimeout(() => {
          btn.textContent = 'Anmelden';
          btn.style.background = '';
        }, 3000);
      }
    });
  }

});
